import * as React from "react"
import SaFaq from "./saFaq"
// @ts-ignore
import { saFaqSection } from "./saFaq.module.scss"
import { saInterfaceFaqSection } from "../saTypes"



class SaFaqContainer extends React.Component<saInterfaceFaqSection>{

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <section  id={'saFaqSection'}
                className={saFaqSection}
      >
        <SaFaq {...this.props}/>
      </section>
    )
  }

}

export default SaFaqContainer